/* eslint-disable no-unused-vars */
import moment from 'moment';

export const displayDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const displayDateTimeFormat2 = 'YYYY-MM-DD LT';
export const displayDateTimeFormat3 = 'YYYY-MM-DD HH:mm A';
export const displayDateFormat = 'YYYY-MM-DD';
export const displayTimeFormat = 'hh:mm A';
export const APIRequestTimeFormat = 'HH:mm:ss';
export const APIRequestDateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const displayImportDateFormat = 'YYYY-MM-DD LT';
export const durationFormatShort = 'm[m] s[s]';
export const durationFormatLong = 'm [min] s [sec]';
export const durationFormatStopWatch = 'mm:ss';

export interface TimeUnitsInterface {
  minutes: number,
  seconds: number,
  ms: number,
}

export interface DateRange {
  startDate?: Date | null;
  endDate?: Date | null;
}

export enum DurationUnits {
  Seconds = 'seconds',
  Minutes = 'minutes',
  Hours = 'hours',
}

export const calculateTimeDifference = (startDate, endDate): TimeUnitsInterface => {
  const momStartDate = moment(startDate);
  const monEndDate = moment(endDate);

  const minutes = monEndDate.diff(momStartDate, 'minutes');
  const seconds = monEndDate.diff(momStartDate, 'seconds');
  const ms = monEndDate.diff(momStartDate, 'ms');

  return { minutes, seconds, ms };
};

export const getDuration = (value: number, unit: DurationUnits, format: string): string => {
  return moment.duration(value < 1 ? 1 : value, unit).format(format, { trim: false });
};

export const convertToUTCStartAndEndOfDay = (range: DateRange): {startDate: Date | null, endDate: Date | null} => {
  const startDateUTC = range.startDate ? new Date(Date.UTC(
    range.startDate.getFullYear(),
    range.startDate.getMonth(), 
    range.startDate.getDate()
  )) : null;

  const endDateUTC = range.endDate ? new Date(Date.UTC(
    range.endDate.getFullYear(),
    range.endDate.getMonth(),
    range.endDate.getDate(),
    23,
    59,
    59
  )) : null;

  return {
    startDate: startDateUTC,
    endDate: endDateUTC
  };
};
